import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";

var _this = this;

//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
import { chartMixins } from './chartMixins';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'pieCircle',
  mixins: [chartMixins],
  props: {
    value: Array,
    text: String,
    subtext: String
  },
  data: function data() {
    return {
      dom: null
    };
  },
  watch: {
    value: function value(newVal) {
      if (this.dom) {
        this.setOption(newVal);
      } else {
        this.init();
      }
    },
    getechartResize: function getechartResize(newVal, oldVal) {
      if (_this.dom) {
        setTimeout(function () {
          _this.resize();
        }, 500);
      }
    }
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    setParams: function setParams(value) {
      var vm = this;
      var legend = value.map(function (_) {
        return _.name;
      });
      this.option = {
        title: {
          x: 'left',
          top: '15',
          left: '5',
          textStyle: {
            fontSize: '14',
            color: 'white',
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          textStyle: {
            color: '#fff'
          },
          type: vm.value.length > 8 ? 'scroll' : '',
          radius: '65%',
          orient: 'vertical',
          left: 10,
          top: 20,
          bottom: 20,
          data: legend,
          show: true,
          formatter: function formatter(name) {
            var _index = 0;
            vm.value.forEach(function (item, i) {
              if (item.name == name) {
                _index = i;
              }
            });
            var arr;
            arr = [name, vm.value[_index].value];
            return arr.join(':  ');
          }
        },
        series: [{
          type: 'pie',
          center: ['65%', '50%'],
          name: this.text,
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: false,
              fontSize: '25',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: this.value
        }]
      };
      return this.option;
    },
    init: function init() {
      var option = this.setParams(this.value);
      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.setOption(option);
      on(window, 'resize', this.resize);
    },
    setOption: function setOption(value) {
      this.dom.setOption(this.setParams(value));
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.init();
    });
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};